const historyTagMapping = {
  '1 (Analyzing Sources Only)': 'Evaluating Evidence',
  '2 (Analyzing Sources + Disciplinary Reasoning)':
    'Evaluating Evidence + Explaining Historical and Geographic Relationships',
  '3 (Disciplinary Reasoning Only)':
    'Explaining Historical and Geographic Relationships',
};

const historySubjectId = 107;

/**
 * Gets the display name for the chosen tag. For history tags, we hardcode a new, more readable tag.
 * For all other courses, we just use the tag name. This translates to the expected tag name.
 * @param tagName - The string name of the tag
 * @param subjectId - The string or integer number of the course ID
 * @returns {string} - The name of the tag to display in the UI.
 */
const getDisplayName = (tagName, subjectId) => {
  const subjectInt = parseInt(subjectId, 10);
  if (subjectInt === historySubjectId) {
    return historyTagMapping[tagName] || tagName;
  }

  return tagName;
};

export default getDisplayName;
